import { Box, Icon, type MediumIcon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  icon: MediumIcon
  text: string
}

const Label = ({ icon, text }: Props) => {
  return (
    <Box flexGrow>
      <Box style={{ float: 'left', paddingRight: '4px' }}>
        <Icon.Medium icon={icon} color="radicalRed1000" />
      </Box>
      <Text size="300" weight="medium" color="grey1000" inline>
        {text}
      </Text>
    </Box>
  )
}

export default Label
